"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _authenticationManager = _interopRequireDefault(require("./authenticationManager"));

var _interceptor = _interopRequireDefault(require("./interceptor"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = ({
  dispatch,
  getters
}) => {
  const authenticationManager = (0, _authenticationManager.default)({
    dispatch,
    getters
  });
  const interceptor = (0, _interceptor.default)(dispatch, authenticationManager);
  return {
    configure: authenticationManager.configure,
    authenticationFailureInterceptor: interceptor.authenticationFailureInterceptor,
    bearerTokenInterceptor: interceptor.bearerTokenInterceptor,
    handleAuthentication: authenticationManager.handleAuthentication,
    getLoginRedirectionUrl: authenticationManager.getLoginUrl,
    exchangeCodeForToken: authenticationManager.exchangeCodeForToken,
    logout: authenticationManager.logout,
    wrapper: interceptor.wrapper
  };
};

exports.default = _default;